export default "__VITE_ASSET__Cbsnw$O9__"